import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'his_cookie_consent';

export function useCookieConsent() {
  const [consent, setConsent] = useState(() => localStorage.getItem(STORAGE_KEY));

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    setConsent('accepted');
  };

  const refuse = () => {
    localStorage.setItem(STORAGE_KEY, 'refused');
    setConsent('refused');
  };

  return { consent, accept, refuse };
}

export default function CookieBanner({ onAccept, onRefuse }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const handleAccept = () => {
    setVisible(false);
    onAccept();
  };

  const handleRefuse = () => {
    setVisible(false);
    onRefuse();
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 300, damping: 30 }}
          className="fixed bottom-0 left-0 right-0 z-[9999] p-4 md:p-6"
          role="dialog"
          aria-label="Consentement aux cookies"
        >
          <div className="max-w-4xl mx-auto bg-[#1B365D] text-white rounded-2xl shadow-2xl px-6 py-5 flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-8">

            {/* Icône */}
            <div className="shrink-0 w-10 h-10 rounded-xl bg-yellow-400 flex items-center justify-center text-[#1B365D] text-xl font-black">
              🍪
            </div>

            {/* Texte */}
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold leading-relaxed text-white/90">
                Nous utilisons des cookies d'analyse (Google Analytics) pour mesurer l'audience du site et améliorer nos services.{' '}
                <Link to="/mentions-legales" className="underline text-yellow-400 hover:text-yellow-300 transition-colors" onClick={handleRefuse}>
                  En savoir plus
                </Link>
              </p>
            </div>

            {/* Boutons */}
            <div className="flex gap-3 shrink-0 w-full md:w-auto">
              <button
                onClick={handleRefuse}
                className="flex-1 md:flex-none px-5 py-2.5 rounded-xl border border-white/20 text-white/70 text-sm font-semibold hover:bg-white/10 transition-colors"
              >
                Refuser
              </button>
              <button
                onClick={handleAccept}
                className="flex-1 md:flex-none px-5 py-2.5 rounded-xl bg-yellow-400 text-[#1B365D] text-sm font-black hover:bg-yellow-300 transition-colors shadow-lg shadow-yellow-400/20"
              >
                Accepter
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
